import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { Constants, PROJECT, ShowStockOutModalTrackingEvent, TrackingEventName } from "./tracking";

interface TrackShowStockOutModalFunctionArgs {
  readonly products: Product[];
  readonly variantId: string;
}

interface TrackShowStockOutModalFunction {
  (args: TrackShowStockOutModalFunctionArgs): void;
}

interface UseTrackShowStockOutModalFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackShowStockOutModalFunction {
  (agrs: UseTrackShowStockOutModalFunctionArgs): TrackShowStockOutModalFunction;
}

const useTrackShowStockOutModal: UseTrackShowStockOutModalFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<ShowStockOutModalTrackingEvent>();

  const trackShowStockOutModal: TrackShowStockOutModalFunction = useCallback(
    ({ products, variantId }) => {
      emitUserEvent({
        event: TrackingEventName.SHOW_STOCK_OUT_MODAL,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        variant_id: variantId,
        items: products.map((product) => ({
          item_id: product._variantId,
          item_list_name: Constants.COMPLETE_YOUR_LOOK_LIST,
          item_price: product.price.amount || 0,
          item_brand: product.brand || Constants.NOT_SET,
          item_list: Constants.COMPLETE_YOUR_LOOK_LIST,
          item_index: Constants.INDEX,
          item_quantity: Constants.QUANTITY,
        })),
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackShowStockOutModal;
};

export { useTrackShowStockOutModal };
